// Configuration for the CDK-deployed notification AppSync API
export const notificationApiConfig = {
  url: "https://id64flmubzcgnahmmzhiq3yypq.appsync-api.us-west-2.amazonaws.com/graphql",
  region: "us-west-2",
  apiKey: "da2-tlbqkkghmza6zkzhrabjy6hsiu",
  authMode: "API_KEY"
};
